import { render, staticRenderFns } from "./SectionTabs.vue?vue&type=template&id=424c91f0&scoped=true"
import script from "./SectionTabs.vue?vue&type=script&lang=js"
export * from "./SectionTabs.vue?vue&type=script&lang=js"
import style0 from "./SectionTabs.vue?vue&type=style&index=0&id=424c91f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c91f0",
  null
  
)

export default component.exports